<template>
	<div>
	</div>
</template>

<script type="text/javascript">

	export default {
		name: 'ExpeditionInvoiceDetail',
		mixins: [],
		data () {
			return {
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {

			},
		},

		components: {
			
		}
	}

</script>